"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
function baggageFactory(baggageInfo) {
  var _baggageInfo$allowanc, _baggageInfo$perPiece, _baggageInfo$perPiece2, _baggageInfo$dimensio;
  var allowance = Number((_baggageInfo$allowanc = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.allowance) !== null && _baggageInfo$allowanc !== void 0 ? _baggageInfo$allowanc : 0);
  var qty = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.qty;
  var quantity = Number(baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.quantity);
  var totalWeight = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.totalWeight;
  var perPieceWeight = (_baggageInfo$perPiece = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.perPieceWeight) !== null && _baggageInfo$perPiece !== void 0 ? _baggageInfo$perPiece : null;
  var perPieceWeightFlag = (_baggageInfo$perPiece2 = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.perPieceWeightFlag) !== null && _baggageInfo$perPiece2 !== void 0 ? _baggageInfo$perPiece2 : null;
  var isCabin = !(0, _isNumber2.default)(quantity);
  var dimensions = (_baggageInfo$dimensio = baggageInfo === null || baggageInfo === void 0 ? void 0 : baggageInfo.dimensions) !== null && _baggageInfo$dimensio !== void 0 ? _baggageInfo$dimensio : null;
  return {
    qty: qty,
    quantity: quantity,
    allowance: allowance,
    totalWeight: totalWeight,
    perPieceWeight: perPieceWeight,
    perPieceWeightFlag: perPieceWeightFlag,
    dimensions: dimensions,
    isCabin: isCabin,
    isIncluded: totalWeight > 0 || allowance > 0
  };
}
var _default = exports.default = baggageFactory;